<template>
  <v-layout column fill-height>
    <v-container>
      <v-layout wrap style="margin: auto; max-width: 960px">
        <v-flex my-3 xs12 display-2>
          Accounts
        </v-flex>
        <v-flex class="account_nav" xs12 hidden-xs-only>
          <div v-for="action in actions"
            :key="action.name"
            @click="navClicked(action)"
            class="nav_cell"
            :class="action.active ? 'nav_cell_active' : ''"
            >
              {{ action.name }}
          </div>
        </v-flex>
        <v-flex class="account_nav_mobile" xs12 hidden-sm-and-up>
          <v-layout wrap >
            <v-flex xs12 v-for="action in actions"
              :key="action.name"
              @click="navClicked(action)"
              class="nav_cell"
              :class="action.active ? 'nav_cell_active' : ''"
              >
                {{ action.name }}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <router-view>
          </router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>

export default {
  data: function () {
    return {
      actions: [
        {
          name: 'Students',
          route: '/account/manage-students',
          active: false
        },
        {
          name: 'My profile',
          route: '/account/manage-account',
          active: false
        },
        {
          name: 'Licenses',
          route: '/account/manage-licenses',
          active: false
        }
      ]
    }
  },
  mounted: function () {
    const isAdmin = this.$store.getters.user.isAdminUser;
    if (isAdmin) {
      this.actions.unshift(
        {
          name: 'Teachers',
          route: '/account/manage-teachers',
          active: false
        }
      );
    }

    if (this.isClassroom) {
      this.$router.push({
        name: 'root'
      })
    }

    if (this.$route.path) {
      const p = this.$route.path;
      this.actions.forEach(action => {
        if (action.route.includes(p)) {
          action.active = true;
        } else {
          action.active = false;
        }
      });
    }
  },
  computed: {
    isClassroom: function () {
      if (this.$store.getters.user.type === 'classroom') {
        return true;
      }
      return false;
    }
  },
  watch: {
    '$route' (to, from) {
      const p = this.$route.path;
      this.actions.forEach(action => {
        if (action.route.includes(p)) {
          action.active = true;
        } else {
          action.active = false;
        }
      });
    }
  },
  methods: {
    navClicked: function (item) {
      item.active = true;

      this.$router.push({
        path: item.route
      })
    }
  }
}
</script>

<style>
.nav_cell {
  font-size: 16px;
  color: #616161;
  display: inline-block;
  padding: 8px 20px;
  cursor: pointer;
  margin: 12px;
  border-radius: 6px;
  background-color: #F5F5F5;
}

.nav_cell_active {
  color: white;
  background-color: #3296f3;
}

.account_nav {
  background-color: #F5F5F5;
  border-radius: 12px;
  height: 64px;
}

.account_nav_mobile {
  background-color: #F5F5F5;
  border-radius: 12px;
}

</style>
